module.exports = __webpack_public_path__ + "static/media/ng.ffd18fe3.svg";